import React, { Component } from 'react';
import MarketTitle from './marketTitle.jsx';
import Orderbook from './Orderbook/index.jsx'
import Charts from '../Middle/charts'
import {isMobile} from 'react-device-detect';

class LeftSide extends Component {
  render() {
    return (
      <div className="col m3" >
        <MarketTitle />
        <div className='col s12' style={{padding: 0}}>
          <Orderbook/>
        </div>
        {isMobile && <Charts/>}
      </div>
		)
  }
}

export default LeftSide
